import React from 'react';

const TableRow = ({row, deleteCard}) => {

  return (
   <tr key={row.cardId}>
    <td className={row.expired ? "table-row-cards expired-card": "table-row-cards" } key={row.brandName}>{row.brandName}</td>
    <td className={row.expired ? "table-row-cards expired-card": "table-row-cards" } key={row.lastFour}>{row.lastFour}</td>
    <td className={row.expired ? "table-row-cards expired-card": "table-row-cards" } key={row.expiryDate}>{row.expiryDate}{row.expired ? " (expired)" : null}</td>
    <td className="table-column-button">
      <button onClick={() => deleteCard(row.cardId)} className="btn-delete-card">Delete card</button>
    </td>
  </tr>);

}

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/UI/TableCards/TableRow/index.js